import commentPoster from './comment-poster.vue';

let Plugin = {},
    vueInstance;

Plugin.install = function (Vue, opt) {
    opt.root.commentPoster = function () {
        // if (!vueInstance) {
        let el = document.createElement('div')
        document.querySelector('body').appendChild(el)

        let vueClass = Vue.extend(commentPoster);

        vueInstance = new vueClass({
            el: el,
            router: opt.router
        })

        return vueInstance.open(...arguments)
    }
}


export default Plugin;
